import React from "react";
import LegalPageShell, { Section } from "./LegalPageShell";

export default function CancellationPolicy() {
  return (
    <LegalPageShell eyebrow="Guest policies" title="Cancellation & Refund Policy" updated="February 2026">
      <p>
        We understand plans change. NewDayStays offers a transparent, tiered refund policy so you always know
        where you stand. This policy applies to all bookings made through <strong>newdaystays.in</strong>.
      </p>

      <Section title="1. Cancellation slabs">
        <p>The refund you receive depends on how far in advance you cancel, calculated from your check-in date:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>30 days or more before check-in</strong> — 90% refund of the total booking amount (10% administrative fee retained)</li>
          <li><strong>15 to 29 days before check-in</strong> — 50% refund</li>
          <li><strong>7 to 14 days before check-in</strong> — 25% refund</li>
          <li><strong>Less than 7 days before check-in</strong> — No refund</li>
          <li><strong>No-show or early check-out</strong> — No refund for unused nights</li>
        </ul>
      </Section>

      <Section title="2. How to cancel">
        <p>
          Email <a href="mailto:newdaystay@gmail.com" className="underline">newdaystay@gmail.com</a> or
          message <a href="https://wa.me/916360734483" className="underline">+91 63607 34483</a> on WhatsApp
          with your booking confirmation ID. Cancellation requests are timestamped when received.
        </p>
      </Section>

      <Section title="3. Refund processing">
        <ul className="list-disc pl-6 space-y-2">
          <li>Refunds are processed to the original payment method within <strong>5–10 working days</strong> of confirmation.</li>
          <li>Razorpay processing fees (~2% + GST) are non-refundable and will be deducted from the eligible refund amount.</li>
          <li>You'll receive a refund reference number via email once the refund is initiated.</li>
        </ul>
      </Section>

      <Section title="4. Date modifications">
        <p>
          Free date changes are permitted up to 14 days before your original check-in, subject to availability
          and any tariff difference. Modifications closer to the check-in date will be treated as a cancellation
          plus a new booking.
        </p>
      </Section>

      <Section title="5. Force majeure & special circumstances">
        <p>
          In case of natural disasters, government-imposed travel restrictions, medical emergencies with valid
          documentation, or property-side issues that make the stay uninhabitable, NewDayStays will offer either
          a <strong>full credit note valid for 12 months</strong> or a full refund at our discretion.
        </p>
      </Section>

      <Section title="6. Group and long-stay bookings">
        <p>
          Bookings for 5+ guests or stays longer than 14 nights follow a customised cancellation schedule that
          is confirmed at the time of booking. Please refer to your booking confirmation for details.
        </p>
      </Section>

      <Section title="7. Overbooking or property unavailability">
        <p>
          In the unlikely event that we are unable to honour a confirmed booking, we will offer you a fully
          refunded stay plus a comparable alternative property (or a full refund plus a 20% goodwill credit).
        </p>
      </Section>
    </LegalPageShell>
  );
}
